import { React, useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import {
  EnhancedAutocomplete,
  CreateValidateTextField,
} from "..";
import { Dialog, DialogTitle, FilledInput, Snackbar, Alert } from "@mui/material";
function ResearchPositionCreate(props) {
  const { userType, username, updateTable, setUpdateTable } = props;

  const [title, setTitle] = useState("");
  const [facultyName, setFacultyName] = useState("");
  const [facultyPid, setFacultyPid] = useState("");
  const [skills, setSkills] = useState([]);

  const [researchPositionDetails, setResearchPositionDetails] = useState("");

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to month because getMonth() returns 0-based index, and pad with leading zero if necessary
  const currentDay = currentDate.getDate().toString().padStart(2, "0"); // pad with leading zero if necessary
  const formattedCurrentDate = `${currentYear}-${currentMonth}-${currentDay}`;
  const [startDate, setStartDate] = useState(formattedCurrentDate);

  const nextDate = new Date();
  nextDate.setDate(currentDate.getDate() + 1);
  const nextYear = nextDate.getFullYear();
  const nextMonth = (nextDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to month because getMonth() returns 0-based index, and pad with leading zero if necessary
  const nextDay = nextDate.getDate().toString().padStart(2, "0"); // pad with leading zero if necessary
  const formattedNextDate = `${nextYear}-${nextMonth}-${nextDay}`;
  const [endDate, setEndDate] = useState(formattedNextDate);

  const [projectUrl, setProjectUrl] = useState("");

  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const [researchPositionCompensation, setResearchPositionCompensation] = useState([]);
  const [researchPositionJobType, setResearchPositionJobType] = useState([]);
  const [researchPositionResearchArea, setResearchPositionResearchArea] = useState([]);
  const [locations, setLocations] = useState([]);

  const [availableSkills, setAvailableSkills] = useState([]);
  const [availableLocations, setAvailableLocations] = useState([]);
  const [availableCompensations, setAvailableCompensations] = useState([]);
  const [availableJobTypes, setAvailableJobTypes] = useState([]);
  const [availableResearchAreas, setAvailableResearchAreas] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleCreateResearchPosition = (event, draft) => {
    event.preventDefault();

    const body = new FormData();
    body.append("pid", userType === "admin" ? facultyPid : username);
    body.append("userType", userType);
    body.append("title", title);
    body.append("facultyName", userType === "admin" ? facultyName : username);
    body.append("researchPositionDetails", researchPositionDetails);
    body.append("startDate", startDate.toString());
    body.append("endDate", endDate.toString());
    body.append("projectUrl", projectUrl);
    body.append("researchPositionCompensation", researchPositionCompensation);
    body.append("skills", skills);
    body.append("researchPositionJobType", researchPositionJobType);
    body.append("researchPositionResearchArea", researchPositionResearchArea);
    body.append("location", locations);
    body.append("draft", draft);

    axios.post("/faculty/createResearchPosition", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenCreateDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  useEffect(() => {
    axios.get("/faculty/skills").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableSkills(data.skills);
      } else {
        return setAvailableSkills([]);
      }
    });
  }, []);

  useEffect(() => {
    axios.get("/faculty/locations").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableLocations(data.locations);
      } else {
        return setAvailableLocations([]);
      }
    });
  }, []);

  useEffect(() => {
    axios.get("/faculty/compensations").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableCompensations(data.compensations);
      } else {
        return setAvailableCompensations([]);
      }
    });
  }, []);

  useEffect(() => {
    axios.get("/faculty/jobTypes").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableJobTypes(data.jobTypes);
      } else {
        return setAvailableJobTypes([]);
      }
    });
  }, []);

  useEffect(() => {
    axios.get("/faculty/researchAreas").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableResearchAreas(data.researchAreas);
      } else {
        return setAvailableResearchAreas([]);
      }
    });
  }, []);


  const resetHooks = () => {
    setTitle("");
    setFacultyName("");
    setResearchPositionCompensation([]);
    setResearchPositionJobType([]);
    setResearchPositionResearchArea([]);
    setSkills([]);
    setStartDate(formattedCurrentDate);
    setEndDate(formattedNextDate);
    setResearchPositionDetails("");
    setProjectUrl("");
    setLocations([]);
    setFacultyPid("");
  };

  function showCreateDialog() {
    return (
      <Dialog open={openCreateDialog} maxWidth={false}>
        <DialogTitle className="ResearchPositionCreate-title mx-auto text-2xl font-bold font-brand-primary">
          Create Research Position Posting
        </DialogTitle>
        <div className="ResearchPositionCreate-modalContainer flex w-fit mb-4 mx-4">
          <div className="ResearchPositionCreate-modalLeftContainer flex flex-col w-fit">
            <div className="ResearchPositionCreate-titleContainer flex flex-col w-96 mx-4 mb-2">
              <div className="ResearchPositionCreate-title text-lg font-brand-primary">
                Title *
              </div>
              <CreateValidateTextField
                placeholder="Junior Software Engineer"
                pattern="(?=.*\w).+"
                value={title}
                setter={setTitle}
                errorMessage={"Invalid Title."}
                required={true}
                maxLength={250}
              />
            </div>
            <div className="ResearchPositionCreate-applicationLinkContainer flex flex-col w-96 mx-4 mb-2">
              <div className="ResearchPositionCreate-applicationLinkTitle text-lg font-brand-primary">
                Project Url
              </div>
              <CreateValidateTextField
                placeholder="https://yoursite.com"
                pattern="(https:\/\/)?(www\.)?((?=[a-zA-Z])[a-zA-Z0-9_-]+(?<=[a-zA-Z])\.)+[a-zA-Z]{2,}\/?(\/?[a-zA-Z0-9-#?_]*)*|[a-zA-Z_.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                value={projectUrl}
                setter={setProjectUrl}
                errorMessage={"Invalid Link."}
                required={false}
                maxLength={1000}
              />
            </div>
            <div className="ResearchPositionCreate-locationContainer flex flex-col w-96 mx-4 mb-2">
              <div className="ResearchPositionCreate-locationTitle text-lg font-brand-primary">
                Location *
              </div>
              <div className="[&>div>div]:mt-1">
                  <EnhancedAutocomplete
                    placeholder="Select location"
                    options={availableLocations}
                    selectedValue={locations}
                    selectedSetter={setLocations}
                    isMultiSelect={false}
                  />
              </div>
            </div>
            <div className="ResearchPositionCreate-researchPositionDescriptionContainer flex flex-col w-96 mx-4 mb-2">
              <div className="ResearchPositionCreate-researchPositionDescriptionTitle text-lg font-brand-primary">
                Research Position Description *
              </div>
              <textarea
                value={researchPositionDetails}
                onChange={(event) => {
                  if (event.target.value.length <= 10000) {
                    setResearchPositionDetails(event.target.value);
                  }
                }}
                className="rounded-xl bg-white p-2 border border-gray-300"
                type="textarea"
                placeholder="Please add details about the research position here!"
                required={true}
              />
            </div>
            <div className="ResearchPositionCreate-dateContainer flex justify-between">
              <div className="ResearchPositionCreate-startDateContainer flex flex-col w-44 ml-4 mb-2">
                <div className="ResearchPositionCreate-startDateTitle text-lg font-brand-primary">
                  Posting Start Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl bg-white border border-gray-300 h-11 [&>input]:pt-2"
                />
              </div>
              <div className="ResearchPositionCreate-endDateContainer flex flex-col w-44 mr-4 mb-2">
                <div className="ResearchPositionCreate-endDateTitle text-lg font-brand-primary">
                  Posting End Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl h-11 bg-white border border-gray-300 [&>input]:pt-2"
                />
              </div>
            </div>
          </div>
          <div className="ResearchPositionCreate-modalRightContainer flex flex-col w-fit">
            <div className="ResearchPositionCreate-researchPositionCompensationsContainer flex flex-col w-96 mx-4 mb-4">
              <div className="ResearchPositionCreate-researchPositionCompensationsTitle text-lg font-brand-primary">
                Research Position Compensation(s) *:
                <div className="[&>div>div]:mt-1">
                  <EnhancedAutocomplete
                    placeholder="Select compensation(s)"
                    options={availableCompensations}
                    selectedValue={researchPositionCompensation}
                    selectedSetter={setResearchPositionCompensation}
                    isMultiSelect={false}
                  />
                </div>
              </div>
            </div>
            <div className="ResearchPositionCreate-researchPositionJobTypeContainer flex flex-col w-96 mx-4 mb-4">
              <div className="ResearchPositionCreate-researchPositionJobTypeTitle text-lg font-brand-primary">
                Research Position Type(s) *:
                <div className="[&>div>div]:mt-1">
                  <EnhancedAutocomplete
                    placeholder="Select Research Position type(s)"
                    options={availableJobTypes}
                    selectedValue={researchPositionJobType}
                    selectedSetter={setResearchPositionJobType}
                  />
                </div>
              </div>
            </div>
            <div className="ResearchPositionCreate-researchPositionResearchAreaContainer flex flex-col w-96 mx-4 mb-4">
              <div className="ResearchPositionCreate-researchPositionResearchAreaTitle text-lg font-brand-primary">
                Research Position Research Area(s) *:
                <div className="[&>div>div]:mt-1">
                  <EnhancedAutocomplete
                    placeholder="Select research(s)"
                    options={availableResearchAreas}
                    selectedValue={researchPositionResearchArea}
                    selectedSetter={setResearchPositionResearchArea}
                  />
                </div>
              </div>
            </div>
            <div className="ResearchPositionCreate-researchPositionSkillsContainer flex flex-col w-96 mx-4 mb-4">
              <div className="ResearchPositionCreate-researchPositionSkillsTitle text-lg font-brand-primary">
                Research Position Skill(s):
                <div className="[&>div>div]:mt-1">
                  <EnhancedAutocomplete
                    placeholder="Select skill(s)"
                    options={availableSkills}
                    selectedValue={skills}
                    selectedSetter={setSkills}
                  />
                </div>
              </div>
            </div>
            {
            userType == "admin" && (
              <div className="ResearchPositionCreate-facultyContainer flex flex-col w-96 mx-4 mb-2">
                <div className="ResearchPositionCreate-facultyTitle text-lg font-brand-primary">
                  Faculty First and Last Name *
                </div>
                <CreateValidateTextField
                  placeholder="Firstname Lastname"
                  pattern="(?=.*\w).+"
                  value={facultyName}
                  setter={setFacultyName}
                  errorMessage={"Invalid Faculty Name."}
                  required={true}
                />
                <div className="ResearchPositionCreate-facultyPid text-lg font-brand-primary">
                  Faculty pid *
                </div>
                <CreateValidateTextField
                  placeholder="fnamelname"
                  pattern="(?=.*\w).+"
                  value={facultyPid}
                  setter={setFacultyPid}
                  errorMessage={"Invalid Faculty pid."}
                  required={true}
                />
              </div>
            )}
          </div>
        </div>
        <div className="ResearchPositionCreate-buttonContainer flex justify-between px-8 mb-4">
          <button
            type="button"
            className="primary-button bg-brand-secondary mb-2 h-11 pt-3"
            onClick={(event) => handleCreateResearchPosition(event, true)}
          >
            Save As Draft
          </button>
          <button
            type="button"
            className="primary-button bg-brand-quaternary mb-2 h-11 pt-3"
            onClick={(event) => handleCreateResearchPosition(event, false)}
          >
            Create Research Position
          </button>
          <button
            type="button"
            className="primary-button bg-brand-primary  mb-2 h-11 pt-3"
            onClick={resetHooks}
          >
            Reset
          </button>
          <button
            type="button"
            className="primary-button bg-brand-primary mb-2 h-11 pt-3"
            onClick={() => {
              setOpenCreateDialog(false);
              resetHooks();
            }}
          >
            Cancel
          </button>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="ResearchPositionCreate-container">
      {showCreateDialog()}
      <button
        type="button"
        className="ResearchPositionCreate-button search-button px-4 h-11 mb-4 mr-4 text-center py-2"
        onClick={() => setOpenCreateDialog(true)}
      >
        Create Research Position
      </button>
    </div>
  );
}

ResearchPositionCreate.propTypes = {
  userType: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  updateTable: PropTypes.bool.isRequired,
  setUpdateTable: PropTypes.func.isRequired,
};

export default ResearchPositionCreate;
